/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Subject_English14Inputs */

const en__field_enum_subject_english14 = /** @type {(inputs: _Field_Enum_Subject_English14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English`)
};

const de__field_enum_subject_english14 = /** @type {(inputs: _Field_Enum_Subject_English14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Englisch`)
};

/**
* | output |
* | --- |
* | "English" |
*
* @param {_Field_Enum_Subject_English14Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_subject_english14 = /** @type {((inputs?: _Field_Enum_Subject_English14Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Subject_English14Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_subject_english14(inputs)
	return de__field_enum_subject_english14(inputs)
});
export { _field_enum_subject_english14 as "_field_enum_SUBJECT_ENGLISH" }